import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MessagesComponent } from './messages.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: MessagesComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class MessagesRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/messages/messages-routing.module.ts